import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Typography } from "@mui/material";

export const CheckoutSuccess = ({ loadingCallback }) => {
  const navigate = useNavigate();

  useEffect(() => {
    setTimeout(() => {
      navigate("/");
    }, 1000);
  }, [navigate]);

  return (
    <Box
      sx={{
        textAlign: "center",
      }}
    >
      <Box
        sx={{
          position: "relative",
          textAlign: "center",
        }}
      >
        <img
          src="/img/thank-you.svg"
          alt="thank you"
          style={{
            margin: "0 0 20px",
            width: "25%",
          }}
        />
        <img
          src={require("../../images/confetti.gif")}
          alt="confetti"
          style={{
            position: "absolute",
            left: "270px",
            top: "-50px",
            margin: "0 0 20px",
            width: "50%",
          }}
        />
        <Typography
          variant="p"
          component="p"
          sx={{
            fontSize: "20px",
            fontFamily: "Open Sans ,sans-serif, Arial",
            margin: "0 0 20px",
            color: "green",
          }}
        >
          Purchase is successful.
        </Typography>
      </Box>
    </Box>
  );
};
